import HeroSection from "./components/HeroSection";
import TrustBar from "../../components/feature/TrustBar";
import ServicesSection from "./components/ServicesSection";
import AIAnswerBlock from "./components/AIAnswerBlock";
import ProcessSection from "./components/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreasSection from "./components/ServiceAreasSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <TrustBar />
      <ServicesSection />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreasSection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTASection />
    </main>
  );
}
